import { render } from "./instruments.vue?vue&type=template&id=b5206cd2&scoped=true"
import script from "./instruments.vue?vue&type=script&lang=js"
export * from "./instruments.vue?vue&type=script&lang=js"

import "./instruments.vue?vue&type=style&index=0&id=b5206cd2&scoped=true&lang=css"

import exportComponent from "D:\\code\\vue\\gaoxinTech\\gaoxin_tech1\\gaoxintech\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b5206cd2"]])

export default __exports__